// Module 5: QA Scoring.
// Receives QA + red flags + defensibility. Returns JSON: score, band, decision, breakdown.

export function buildScoringMessage({ qaText, redFlagsText, defensibilityText, fileName }) {
  return `Customer file under review: ${fileName || 'untitled'}

--- KYC QA ASSESSMENT ---
${qaText}

--- RED FLAGS ---
${redFlagsText}

--- DEFENSIBILITY ASSESSMENT ---
${defensibilityText}

--- END INPUTS ---

Compute the score and final decision. Return only the JSON object specified in your instructions. The breakdown numbers must add up to the total score.`;
}
